<template>
  <section class="section">
    <Loader :isLoading="this.isLoading"></Loader>
  </section>
</template>

<script>
  /* Services */
  import Contentful from '@/services/Contentful'

  /* Components */
  import Loader from '@/components/General/Loader'

  export default {
    data () {
      return {
        isLoading: true
      }
    },
    async mounted () {
      try {
        /* Get Slug */
        const slug = this.$store.state.route.params.slug
        /* Get redirect url */
        const redirectUrls = (await Contentful.getAllEntriesByContentType('redirectUrls')).data.items || []
        const redirectToItem = redirectUrls.filter((item) => {
          return (item.fields.slug === slug)
        })[0] || null

        /* Redirect */
        if (redirectToItem) {
          window.location.href = redirectToItem.fields.redirectTo
        } else {
          window.location.href = '/'
        }
      } catch (error) {
        window.location.href = '/'
      }
    },
    components: {
      Loader
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Pages/Redirect.vue